theme.headerSticky = (function () {
  function ScrollSticky() {
    const headerStickyTargetList = document.querySelectorAll(".header__sticky");

    if (headerStickyTargetList.length > 0) {
      headerStickyTargetList.forEach((headerStickyTarget) => {
        // If a placeholder spacer immediately follows this target, keep it in
        // sync so the page doesn't jump when the target leaves normal flow
        // (position: fixed) and reappears pinned to the top.
        const nextEl = headerStickyTarget.nextElementSibling;
        const placeholder =
          nextEl && nextEl.classList.contains("header__sticky--placeholder")
            ? nextEl
            : null;

        // Capture the target's natural (pre-sticky) position once, before any
        // scrolling happens. Re-measuring this on every scroll tick (against a
        // moving/position:fixed element) caused the threshold to collapse to
        // ~0, which made the header snap to fixed immediately and overlap the
        // announcement bar instead of waiting until it had scrolled past.
        let targetOffset = TopOffset(headerStickyTarget).top;

        function setSticky(isSticky) {
          if (isSticky === headerStickyTarget.classList.contains("sticky")) return;

          if (isSticky) {
            if (placeholder) {
              placeholder.style.height = headerStickyTarget.offsetHeight + "px";
              placeholder.classList.add("active");
            }
            headerStickyTarget.classList.add("sticky");
          } else {
            headerStickyTarget.classList.remove("sticky");
            if (placeholder) placeholder.classList.remove("active");
          }
        }

        window.addEventListener("resize", function () {
          if (!headerStickyTarget.classList.contains("sticky")) {
            targetOffset = TopOffset(headerStickyTarget).top;
          }
        });

        window.addEventListener("scroll", function () {
          setSticky(window.scrollY > targetOffset);
        });
      });
    }
  }
  return ScrollSticky;
})();
